const envConfig = {
  apiBaseUrl: process.env.VITE_APP_API_BASE_URL ?? '',
  baseUrl: process.env.VITE_APP_BASE_URL ?? '',
  env: process.env.VITE_APP_ENV ?? '',
  msAzureAdAuthority: process.env.VITE_APP_MS_AZURE_AD_AUTHORITY ?? '',
  msAzureAdClientId: process.env.VITE_APP_MS_AZURE_AD_CLIENT_ID ?? '',
  msAzureAdKnownAuthority: process.env.VITE_APP_MS_AZURE_AD_KNOWN_AUTHORITY ?? '',
  msAzureAdScope: process.env.VITE_APP_MS_AZURE_AD_SCOPE ?? '',
  sentryAuthToken: process.env.VITE_APP_INPUT_SENTRY_AUTH_TOKEN ?? '',
  sentryDsnUrl: process.env.VITE_APP_INPUT_SENTRY_DSN_URL ?? '',
  sentryEnvironment: process.env.VITE_APP_SENTRY_ENVIRONMENT ?? '',
  sentryOrganization: process.env.VITE_APP_SENTRY_ORGANIZATION ?? '',
  sentryProject: process.env.VITE_APP_INPUT_SENTRY_PROJECT ?? '',
};

export default envConfig;
